import { CaretDown, CaretRight } from "@phosphor-icons/react";

export const SECTION_ORDER = [
  { id: "personal", label: "Personal" },
  { id: "summary", label: "Summary" },
  { id: "experience", label: "Experience" },
  { id: "education", label: "Education" },
  { id: "skills", label: "Skills" },
  { id: "projects", label: "Projects" },
  { id: "certifications", label: "Certifications" },
];

export function Section({ id, title, open, onToggle, children }) {
  const idx = SECTION_ORDER.findIndex((s) => s.id === id);
  return (
    <div className="border-b border-black/10" data-testid={`section-${id}`}>
      <button
        onClick={onToggle}
        className="w-full flex items-center justify-between py-4 text-left group"
        data-testid={`section-toggle-${id}`}
      >
        <div className="flex items-center gap-3">
          <span className="font-mono text-xs text-neutral-400">
            {String(idx + 1).padStart(2, "0")}
          </span>
          <span className="font-heading font-semibold text-lg tracking-tight">{title}</span>
        </div>
        {open ? <CaretDown size={16} weight="bold" /> : <CaretRight size={16} weight="bold" />}
      </button>
      {open && <div className="pb-6 pt-1">{children}</div>}
    </div>
  );
}

export function Field({ label, children, testid }) {
  return (
    <label className="block" data-testid={testid ? `field-${testid}` : undefined}>
      <div className="label-mono mb-1.5">{label}</div>
      {children}
    </label>
  );
}
